__turbopack_context__.v({
  "backdrop": "home-content-module-scss-module__cXi-FG__backdrop",
  "backdrop-asterisk": "home-content-module-scss-module__cXi-FG__backdrop-asterisk",
  "backdrop-asterisk-spin": "home-content-module-scss-module__cXi-FG__backdrop-asterisk-spin",
  "backdrop-subtitle": "home-content-module-scss-module__cXi-FG__backdrop-subtitle",
  "backdrop-title": "home-content-module-scss-module__cXi-FG__backdrop-title",
  "home-content": "home-content-module-scss-module__cXi-FG__home-content",
});
